import cx from 'classnames'

import { Message, MessageType } from 'lib/_types'

import ImageLoader from 'components/ImageLoader'
import { ChatMessageReplyPreviewText } from './ChatMessageReplyPreviewText'

import { useMessageMediaInfo } from '../hooks'
import './style.scss'

type Props = {
  message: Message
  isCurrentUserMessage: boolean
}

const ALLOWED_TYPE: Readonly<MessageType[]> = [
  'gif',
  'sticker',
  'image',
  'eternal_image',
  'video',
  'eternal_video',
]

export const ChatMessageReplyPreviewMedia = ({
  message,
  isCurrentUserMessage,
}: Props) => {
  if (!ALLOWED_TYPE.includes(message?.message_type)) return null

  const { text, thumbnailPath, iconPath, isOneTime, shouldRender } =
    useMessageMediaInfo({
      message,
      isCurrentUserMessage,
    })

  if (!shouldRender)
    return (
      <ChatMessageReplyPreviewText iconPath={iconPath}>
        {text}
      </ChatMessageReplyPreviewText>
    )

  if (isOneTime && !isCurrentUserMessage) return null

  return (
    <div
      className={cx('ChatMessageReplyPreviewMedia', {
        [`ChatMessageReplyPreviewMedia--${message?.message_type}`]:
          message?.message_type,
      })}
    >
      <ImageLoader url={thumbnailPath} preserveHeight="112px" />
    </div>
  )
}
